function get_host(s){
                    if (typeof s!='string')
                        return;
                    var a = s.match(/\/\/([^\/]*)\//);
                    return a && a[1];
                }
                